// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Datepicker from 'vuejs-datepicker'
import { en } from 'vuejs-datepicker/dist/locale'
import Sweetalert from 'vue-sweetalert2'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import Vuelidate from 'vuelidate'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Select2 from './views/_shared/Select'
import App from './App.vue'
import router from './router.js'
import store from './store'
import VueAutosuggest from 'vue-autosuggest'
import 'vue-search-select/dist/VueSearchSelect.css'

window.mm = require('music-metadata-browser')
window.util = require('util')

const snotifyOptions = {
    toast: {
        position: SnotifyPosition.rightBottom,
        timeout: 1000,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true
    }
}

Vue.config.devtools = true;
Vue.use(BootstrapVue)
Vue.use(Sweetalert)
Vue.use(Snotify, snotifyOptions)
Vue.use(Vuelidate)
Vue.use(VueAutosuggest)

Vue.filter('state', (value, dirtyOnly = true) => {
    if (dirtyOnly) {
        if (!value.$dirty)
        return null
    }

    return !value.$invalid ? 'valid' : 'invalid'
})

Vue.filter('doubleDigits', function (val) {
  if(isNaN(val)){
    return '00'
  }else{
    return val < 10 ? '0' + val : val
  }
})

Vue.component('loading', {
    extends: Loading,
    props  : {
        opacity: {
            type   : Number,
            default: 0.7,
        },
        color: {
            type   : String,
            default: '#63c2de',
        },
        isFullPage: {
            type   : Boolean,
            default: false,
        },
        height: {
            type   : Number,
            default: 32,
        },
        width: {
            type   : Number,
            default: 32,
        },
        zIndex: {
            type   : Number,
            default: 100000,
        },
    }
})
Vue.component('b-select-2', Select2)
Vue.component('b-datepicker', {
    extends: Datepicker,
    props  : {
        bootstrapStyling: {
            type   : Boolean,
            default: true,
        },
        language: {
            type   : Object,
            default: () => en,
        },
    },
})

export default new Vue({
    el        : '#app',
    router    : router,
    store     : store,
    components: { App },
    template  : '<App/>',
})
